import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import {Card} from '@mui/material';

import {Color, SpectraLogoColor} from 'spectra-logic-ui/colors';
import {Table, Tooltip} from 'spectra-logic-ui/components';

import {Aggregate} from '@/types';
import {recoverableTooltip} from '@/storage/details/properties';

type Props = {
  aggregate: Aggregate;
}

const useStyles = makeStyles({
  tableCell: {
    color: Color.WHITE,
  },
  card: {
    margin: 20,
  },
  row: {
    background: SpectraLogoColor.BLUE,
    height: 47,
  },
});

const AggregateProperties = ({aggregate}: Props) => {
  const classes = useStyles();

  return (
    <>
      <Table>
        <Table.Body>
          <Table.Row>
            <Table.Cell>ID</Table.Cell>
            <Table.Cell>{aggregate.id}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Storage Class</Table.Cell>
            <Table.Cell>{aggregate.storageClass}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Use With Buckets</Table.Cell>
            <Table.Cell>{aggregate.useWith && aggregate.useWith.length > 0 ?
              aggregate.useWith.join(', ') : 'All buckets'}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Current Version Only</Table.Cell>
            <Table.Cell>{aggregate.currentOnly ? 'Enabled' : 'Disabled'}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Third-party Recovery<Tooltip>{recoverableTooltip}</Tooltip></Table.Cell>
            <Table.Cell>{aggregate.recoverable ? 'Enabled' : 'Disabled'}</Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
      <Card className={classes.card}>
        <Table size='small'>
          <Table.Header>
            <Table.Row className={classes.row}>
              <Table.Cell className={classes.tableCell}>Storage ID</Table.Cell>
              <Table.Cell className={classes.tableCell}>Name</Table.Cell>
              <Table.Cell className={classes.tableCell}>Weight</Table.Cell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {(aggregate.storage || []).map((s) => (
              <Table.Row key={s.id}>
                <Table.Cell>{s.id}</Table.Cell>
                <Table.Cell>{s.name}</Table.Cell>
                <Table.Cell>{s.weight}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </Card>
    </>
  );
};

export default AggregateProperties;
